import { VueConstructor } from 'vue';
import { DataType } from '@/core/data/DataType';
import { Settings } from '@/core/Settings';
import { Common } from '@/core/Common';

export class DashboardTabWrapper {
    constructor (
        public component: VueConstructor,
        public name: string,
        public iconHtml: string,
        public url: string,
        public requiredTypes: DataType[],
        public canBeDisplayed: () => boolean
    ) { }

    public onDisplayed(): void {
        document.title = Settings.DefaultTitle + " − " + this.name;
        window.history.replaceState(null, document.title, "#" + this.url);
    }

    public onClosed(): void {
        document.title = Settings.DefaultTitle;
        window.history.replaceState(null, document.title, "#");
    }

    public isDisplayed(): boolean {
        return Common.GetHash() == this.url;
    }
}